import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryControl } from "./baseQuery";
import { toast } from "react-toastify";

export const controlServiceApi = createApi({
  baseQuery: baseQueryControl,
  reducerPath: "control",

  endpoints: (builder) => ({
    controlPost: builder.mutation({
      query: (req) => ({
        url: req.path,
        method: "POST",
        body: req.datas,
      }),
      transformErrorResponse: (err) => {
        if (err.status === "FETCH_ERROR") {
          toast.error("Network Error");
        }

        if (err.status === 404 && !err?.data?.statusMessage) {
          toast.error("invalid API", "error");
        } else if (err.status === 500) {
          toast.error(
            "Something went wrong. It’s not you, it’s us. Please give it another try.",
            "error"
          );
        } else if (err.status === 401) {
          toast.error("session has expired login, please login to continue ");
          localStorage.removeItem("token");
          window.location.replace("/");
        }
        return err;
      },
    }),
    controlGet: builder.query({
      query: (queries) => queries,
      transformErrorResponse: (err) => {
        if (err.status === "FETCH_ERROR") {
          toast.error("Network Error");
        } else if (err.status === 500) {
          toast.error(
            "Something went wrong. It’s not you, it’s us. Please give it another try."
          );
        } else if (err.status === 401) {
          toast.error("session has expired login, please login to continue ");
          localStorage.removeItem("token");
          window.location.replace("/");
        }
        return err;
      },
    }),
    getReasons: builder.query({
      query: (payload) => ({
        url: `/DeclineSetup`,
        method: "GET",
        params: {
          Page: payload.Page,
          PageNumber: payload.PageNumber,
          PageSize: payload.PageSize,
          Search: payload.search,
          ModuleSetupId: payload?.module,
          ApprovalStatus: payload.ApprovalStatus,
        },
      }),
    }),
  }),
});

export const {
  useControlGetQuery,
  useControlPostMutation,
  useGetReasonsQuery,
} = controlServiceApi;
